module.exports = __webpack_public_path__ + "static/matchday-report-f9759d61b8c815b72fcc6c6c0dc59507.png";